module.exports = __webpack_public_path__ + "static/media/OXG.feed557a.png";